var _path, _path2, _path3, _circle, _circle2, _rect, _rect2, _rect3, _rect4, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfettiRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 550,
    viewBox: "0 0 293 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1982 476.88L73.3293 524.541L53.1893 531.644L45.1982 476.88Z",
    fill: "#EAD300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.646 183.429L154.668 236.978L135.433 227.698L168.646 183.429Z",
    fill: "#EAD300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.162 233.071L46.7208 288.025L25.4257 286.417L40.162 233.071Z",
    fill: "#EAD300"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161.44,
    cy: 357.822,
    r: 4.62367,
    fill: "#9F00EA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.789,
    cy: 326.235,
    r: 10.7886,
    fill: "#EAA900"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 228.809,
    y: 449.456,
    width: 30.8245,
    height: 15.4122,
    transform: "rotate(-45.5869 228.809 449.456)",
    fill: "#EAA900"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8184,
    y: 339.188,
    width: 9.24734,
    height: 15.4122,
    transform: "rotate(-24.1997 13.8184 339.188)",
    fill: "#EA0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 224.842,
    y: 364.119,
    width: 36.9894,
    height: 12.3298,
    transform: "rotate(-56.6149 224.842 364.119)",
    fill: "#EA0000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 163.652,
    y: 464.736,
    width: 36.9894,
    height: 12.3298,
    transform: "rotate(-116.768 163.652 464.736)",
    fill: "#EA0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9317 382.721C43.9317 382.721 63.6417 372.904 68.113 378.049C70.5694 380.876 72.4245 384.3 70.2245 387.082C68.5286 389.226 66.0802 389.499 63.2114 388.996C57.1363 387.929 57.2285 379.492 59.6671 374.267C63.0341 367.054 80.9074 371.312 80.9074 371.312",
    stroke: "#05EA00",
    strokeWidth: 3.69894
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.488 495.105C217.488 495.105 225.593 491.102 228.534 494.714C231.005 497.749 225.587 502.653 228.735 504.811C231.923 506.996 233.436 498.692 236.917 500.202C240.581 501.79 240.041 510.591 240.041 510.591",
    stroke: "#005EEA",
    strokeWidth: 3.69894
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2192 169.518C70.2192 169.518 73.4796 161.087 78.0894 161.758C81.9622 162.322 81.2894 169.598 85.0671 169.058C88.8937 168.511 84.3908 161.372 87.9758 160.129C91.7488 158.82 97.3046 165.667 97.3046 165.667",
    stroke: "#005EEA",
    strokeWidth: 3.69894
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5101 14.5976C16.5101 22.2583 28.7889 28.4686 20.2445 28.4686C11.7001 28.4686 4.77344 22.2583 4.77344 14.5976C4.77344 6.93682 11.7001 0.726562 20.2445 0.726562C28.7889 0.726562 16.5101 6.93682 16.5101 14.5976Z",
    fill: "#9F00EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.489 111.469C163.489 119.129 175.767 125.34 167.223 125.34C158.679 125.34 151.752 119.129 151.752 111.469C151.752 103.808 158.679 97.5977 167.223 97.5977C175.767 97.5977 163.489 103.808 163.489 111.469Z",
    fill: "#9F00EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.803 265.312L280.263 275.962H291.461L282.402 282.543L285.862 293.193L276.803 286.611L267.744 293.193L271.204 282.543L262.145 275.962H273.343L276.803 265.312Z",
    fill: "#05EA00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.669 522.643L145.745 529.032H152.464L147.029 532.981L149.105 539.371L143.669 535.422L138.234 539.371L140.31 532.981L134.874 529.032H141.593L143.669 522.643Z",
    fill: "#EAD300"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.253 266.589L171.872 258.535L174.381 270.954L183.243 264.148L185.144 275.847L195.916 269.732",
    stroke: "#005EEA",
    strokeWidth: 3.08245
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiRight);
export default __webpack_public_path__ + "static/media/confettiRight.a91a1e76.svg";
export { ForwardRef as ReactComponent };